export function checkIfUserIsOwner(site: any, userId: number, userPermissionLevel = 3): boolean {
	if (userPermissionLevel && userPermissionLevel !== 3) {
		return true;
	} else if (site?.sharedUserVOs) {
		const sharedUser = site.sharedUserVOs?.find((sharedUserVO: { id: number; }) => sharedUserVO.id === userId);
		return sharedUser?.owner ?? false;
		
	} else if (site?.coOwnerInd) {
		return site.coOwnerInd;
	} else {
        return false;
    }
}